import { NgModule } from '@angular/core';
import { MatNativeDateModule } from '@angular/material/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthModule } from './auth/auth.module';
import { MenuModule } from './menu/menu.module';
import { NopagefoundComponent } from './nopagefound/nopagefound.component';
/**
 * Modulo principal de la aplicacion
 */
@NgModule({
  declarations: [
    AppComponent,
    NopagefoundComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    LazyLoadImageModule,
    AuthModule,
    MenuModule,
    MatNativeDateModule,
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
